module.exports = __webpack_public_path__ + "img/italy-colorectal-cancer-male.6ed735b9.png";